import axios from 'axios';

const url = '/api/v1/editors_picks';

export function getPicks() {
  return axios.get(url);
}

export function updatePicks(picks) {
  return axios.post(url, { picks });
}
